<template>
  <div class="d-flex flex-column">
    <div class="d-flex align-center">
      <h4>{{ label }}</h4>
      <text-name-information-card v-if="textNameDisplayHelp" />
      <transliteration-information-card v-if="transliterationDisplayHelp" />
      <v-dialog v-model="helpOpen" width="500">
        <v-card>
          <v-card-title>Help</v-card-title>
          <v-card-text>
            <slot name="help-body"></slot>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-text-field
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      @keyup.enter="$emit('enter')"
      :bg-color="disabled ? 'grey' : 'white'"
      theme="light"
      :disabled="disabled"
      type="text"
      variant="filled"
      density="compact"
      hide-details
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TransliterationInformationCard from '@/views/Search/TextsSearch/components/TransliterationInformationCard.vue';
import TextNameInformationCard from '@/views/Search/TextsSearch/components/TextNameInformationCard.vue';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    textNameDisplayHelp: {
      type: Boolean,
      default: false,
    },
    transliterationDisplayHelp: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'enter'],
  components: {
    TransliterationInformationCard,
    TextNameInformationCard,
  },
  setup() {
    const helpOpen = ref(false);

    return {
      helpOpen,
    };
  },
});
</script>
